import { useEffect } from 'react'
import useCookieConsent from '@App/common/hooks/use-cookie-consent'
import { loadSegment, setSegmentConsent } from '@App/configs/segment-config'

const useSegmentConsent = () => {
    const hasStatisticsConsent = useCookieConsent('statistics')
    const segmentKey = window.APP_CONFIG.SEGMENT_KEY

    useEffect(() => {
        if (hasStatisticsConsent && segmentKey) {
            loadSegment(segmentKey)
        }
        setSegmentConsent(hasStatisticsConsent)
    }, [hasStatisticsConsent, segmentKey])
}

export default useSegmentConsent
